import type { ReactElement } from "react";

import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { useGetEventProxyQuery } from "../../graphql/event.hooks";
import {
  EventDisplayStatusEnum,
  EventStatusEnum,
} from "../../graphql/schema/types";

import Wrapper from ".";

interface IWithEventEditAccessProps {
  children: ReactElement;
  eventId?: number;
}

export default function WithEventEditAccess({
  children,
  eventId: eventIdProp,
}: IWithEventEditAccessProps) {
  const navigate = useNavigate();
  const { id, eventId: eventIdParam, locale } = useParams();
  const eventId = Number(id ?? eventIdParam ?? eventIdProp ?? 0);

  const { data, loading } = useGetEventProxyQuery({
    variables: { eventId, locale },
    skip: !eventId,
  });

  const event = data?.eventProxy;
  const isEditBlocked =
    event?.displayStatus === EventDisplayStatusEnum.Finished ||
    event?.statusKey === EventStatusEnum.Archived;

  useEffect(() => {
    if (isEditBlocked) {
      navigate(-1);
    }
  }, [isEditBlocked, navigate]);

  if (eventId && (loading || isEditBlocked)) {
    return (
      <Wrapper>
        <div className="d-flex align-items-center justify-content-center py-5">
          <Spinner animation="border" role="status" />
        </div>
      </Wrapper>
    );
  }

  return children;
}
